const PROMOCODES = [
    {
        promocode: 'isic',
        partnerCode: 'MTAwMTEwMDE1MDAwMDM1',
    },
    // {
    //     promocode: 'black',
    //     partnerCode: 'kl3fuA05oaz6g5a',
    // },
]

export default PROMOCODES
